import { useState } from 'react'
import { Link } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { CashInputField } from '@/components/rebalance/CashInputField'
import { ClusterDriftSection } from '@/components/rebalance/ClusterDriftSection'
import { PositionDriftSection } from '@/components/rebalance/PositionDriftSection'
import { ProposedActionsSection } from '@/components/rebalance/ProposedActionsSection'
import { useRebalanceView } from '@/lib/useRebalanceView'

export function RebalancePage() {
  const [cashInput, setCashInput] = useState<number | null>(null)
  const query = useRebalanceView(cashInput)

  return (
    <AppShell>
      <div className="mx-auto max-w-5xl">
        <h1 className="tracked-caps mb-6 text-sm text-ink">Rebalancing</h1>

        <CashInputField
          onChange={setCashInput}
          recordedCashEur={query.data?.recorded_cash_eur ?? null}
        />
        {query.data && <ProposedActionsSection actions={query.data.proposed_actions} />}

        {query.isLoading && <p className="text-sm text-muted">Lade Rebalancing-Daten …</p>}

        {query.data && !query.data.has_active_strategy && (
          <section className="hairline border bg-panel p-6 text-sm text-ink">
            Keine aktive Strategie vorhanden.{' '}
            <Link to="/strategy" className="text-bernstein hover:underline">
              Strategie aktivieren
            </Link>{' '}
            um Drift-Analyse zu sehen.
          </section>
        )}

        {query.data?.has_active_strategy &&
          query.data.cluster_drifts.length === 0 &&
          query.data.position_drifts.length === 0 && (
            <section className="hairline border border-gain/40 bg-gain/5 p-6 text-sm text-gain">
              ✓ Portfolio im Ziel-Korridor — keine Drift-Trigger aktiv.
            </section>
          )}

        {query.data && query.data.cluster_drifts.length > 0 && (
          <ClusterDriftSection drifts={query.data.cluster_drifts} />
        )}

        {query.data && query.data.position_drifts.length > 0 && (
          <PositionDriftSection drifts={query.data.position_drifts} />
        )}
      </div>
    </AppShell>
  )
}
